"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfileImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing UserProfile operations. */
var UserProfileImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class UserProfile class.
   * @param client Reference to the service client
   */
  function UserProfileImpl(client) {
    (0, _classCallCheck2["default"])(this, UserProfileImpl);
    this.client = client;
  }
  /**
   * Intended for API tests as no user is created in the Mocked Authentication flow (Auth: Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(UserProfileImpl, [{
    key: "createOrUpdateUser",
    value: function createOrUpdateUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createOrUpdateUserOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getUserProfile",
    value: function getUserProfile(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getUserProfileOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getCurrentUserVerifiedEmailAddresses",
    value: function getCurrentUserVerifiedEmailAddresses(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getCurrentUserVerifiedEmailAddressesOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "setProfileEmail",
    value: function setProfileEmail(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, setProfileEmailOperationSpec);
    }
  }]);
  return UserProfileImpl;
}(); // Operation Specifications


exports.UserProfileImpl = UserProfileImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var createOrUpdateUserOperationSpec = {
  path: "/api/Portals({portalId})/userprofile",
  httpMethod: "PUT",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  serializer: serializer
};
var getUserProfileOperationSpec = {
  path: "/api/Portals({portalId})/userprofile",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.UserProfileDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getCurrentUserVerifiedEmailAddressesOperationSpec = {
  path: "/api/Portals({portalId})/CurrentUser/VerifiedEmailAddresses",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var setProfileEmailOperationSpec = {
  path: "/api/Portals({portalId})/userprofile/email",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.UserProfileDto
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body25,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};